<template>
    <toolbar-option>
        <template slot="primary">
            <toggle
                :value="isChecked"
                :messages="messages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'boxed',
    mixins: [baseOption],

    data() {
        return {
            isChecked: false,
            displayName: 'Boxed Layout',

            messages: {
                checked: 'On',
                unchecked: 'Off',
            },

            tailwindDefinitionProp: 'boxed',
        };
    },

    watch: {
        changedOption({ option, sides }) {
            const conflictingSides = ['l', 'r', 'x'];
            const hasConflictingSide = sides.some(s => conflictingSides.includes(s));

            switch (true) {
                case option === 'max-width':
                case (option === 'margin' && hasConflictingSide):
                case (option === 'padding' && hasConflictingSide):
                    this.onConflict();
                    break;

                default:
                    // do nothing
            }
        },
    },

    methods: {
        onInput(isChecked) {
            let flexClassNew;

            if (isChecked) {
                flexClassNew = this.addFlexClass({});
            } else {
                this.removeFlexClass('default');
            }

            this.isChecked = isChecked;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            this.isChecked = !!this.flexClassGroup[this.screen].default;
        },

        onConflict() {
            // fired when conflicting classes are added, and clears all boxed classes
            // otherwise certain options may stop having any effect, leading to a confusing UX
            this.removeFlexClass();
            this.isChecked = false;
        },
    },
};
</script>
